import { render, staticRenderFns } from "./LegacyChatbot.vue?vue&type=template&id=25fad287&scoped=true"
import script from "./LegacyChatbot.vue?vue&type=script&lang=js"
export * from "./LegacyChatbot.vue?vue&type=script&lang=js"
import style0 from "./LegacyChatbot.vue?vue&type=style&index=0&id=25fad287&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fad287",
  null
  
)

export default component.exports